import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { SoHealthAdditionalInfoType } from "src/common/api/apollo/additional/types/types";


export interface SoHealthAdditionalInfo {
  physicalExamination: SoHealthAdditionalInfoType['physicalExamination'] | null;
  specialistExaminations: boolean;
  diagnostic: boolean;
  laboratoryExaminations: SoHealthAdditionalInfoType['laboratoryExaminations'] | null;
  mrCt: boolean;
  physicalTherapy: boolean;
  smallOperatingCycles: boolean;
  reasonOfPurchase: string;
  perMonthPayment: string;
}

export interface ExamState {
  data: SoHealthAdditionalInfo | null;
}

const initialState: ExamState = {
  data: {
    physicalExamination: null,
    specialistExaminations: false,
    diagnostic: false,
    laboratoryExaminations: null,
    mrCt: false,
    physicalTherapy: false,
    smallOperatingCycles: false,
    reasonOfPurchase: '',
    perMonthPayment: '',
  },
};

export const examSlice = createSlice({
  name: 'exam',
  initialState,
  reducers: {
    setExamDraft: (state: ExamState, action: PayloadAction<SoHealthAdditionalInfo | null>) => {
      state.data = action.payload;
    },
  },
});

export const { setExamDraft } = examSlice.actions;

export default examSlice.reducer;
